import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "config-list-table__currency-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrencyTable = _resolveComponent("CurrencyTable")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "config-list-table" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "tableRef",
        border: "",
        size: "small",
        class: "config-list-table__content",
        "tooltip-effect": "light",
        data: _ctx.cashierConfigList,
        "row-class-name": _ctx.getRowClassName,
        "default-sort": _ctx.defaultCashierSortState,
        onSortChange: _ctx.changeColumnSort
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cashierConfigListColumns, (column) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: column.value,
              prop: column.value,
              label: column.label,
              width: column.width,
              align: column.align,
              sortable: column.isSortable,
              type: _ctx.getColumnType(column)
            }, {
              default: _withCtx(({ row, $index }) => [
                (_ctx.getCurrencyTableVisibility(row, column))
                  ? (_openBlock(), _createBlock(_component_CurrencyTable, {
                      key: 0,
                      row: row
                    }, null, 8 /* PROPS */, ["row"]))
                  : _createCommentVNode("v-if", true),
                (column.value === _ctx.CashierSettingsColumnProperties.ID)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString($index + 1), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (column.value === _ctx.CashierSettingsColumnProperties.CURRENCY)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.getCurrencyListFromConfig(row).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCurrencyListFromConfig(row), (tag) => {
                              return (_openBlock(), _createBlock(_component_el_tag, {
                                key: tag,
                                type: "info"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(tag), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" No data ")
                          ], 64 /* STABLE_FRAGMENT */))
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (column.value === _ctx.CashierSettingsColumnProperties.RECOMMENDED_METHOD_COUNT)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      class: _normalizeClass({ 'config-list-table__text--grey': !row.recommendedMethods })
                    }, _toDisplayString(row.recommendedMethods || 'Not selected'), 3 /* TEXT, CLASS */))
                  : (column.value === _ctx.CashierSettingsColumnProperties.ACTIONS)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 4,
                        circle: "",
                        size: "small",
                        icon: _ctx.icons.Setting,
                        disabled: !_ctx.isChangeCountrySettingsAvailable,
                        onClick: ($event: any) => (_ctx.setSelectedCountry(row.country))
                      }, null, 8 /* PROPS */, ["icon", "disabled", "onClick"]))
                    : _createCommentVNode("v-if", true)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["prop", "label", "width", "align", "sortable", "type"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data", "row-class-name", "default-sort", "onSortChange"])), [
        [_directive_loading, _ctx.isCashierConfigListLoading]
      ])
    ]),
    _: 1 /* STABLE */
  }))
}